import { Paper } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import ArchiveIcon from '@material-ui/icons/Archive'
import DescriptionIcon from '@material-ui/icons/Description'
import UnarchiveIcon from '@material-ui/icons/Unarchive'
import React, { useState } from 'react'
import { TABLE_TYPE } from '../../context/TableContext'
import { useCoutContractAll } from '../../hooks/useCountContractAll'
import MsgsReceivedListMin from '../MsgsReceivedList/MsgsReceivedListMin'
import MsgsSentListMin from '../MsgsSentList/MsgsSentListMin'
import MsgsSubmissionsListMin from '../MsgsSubmissionsList/MsgsSubmissionsListMin'
import EkomContractActionsBtn from './EkomContractActionsBtn'
import { useStyles } from './styles'

interface iEkomContractActions {
  extSystemId: string
  extObjectId: string
  contractSlug?: string
  canCreateMsg?: boolean
  contractExtUrl?: string
  ekomunikaceEnabled?: boolean
}

const EkomContractActions = ({
  extSystemId,
  extObjectId,
  contractSlug,
  canCreateMsg,
  contractExtUrl,
  ekomunikaceEnabled
}: iEkomContractActions) => {
  const classes = useStyles()

  const [selectTab, setSelectTab] = useState('')

  const counts = useCoutContractAll(extObjectId)
  return (
    <Paper elevation={1} id="contract-msgs" className={classes.ekomBox}>

      <Box display="flex" justifyContent="space-between">
        <Box>
          <h2 className={classes.ekomTitle}>eKomunikace k zakázce</h2>
          {ekomunikaceEnabled && canCreateMsg &&
            <EkomContractActionsBtn
              extSystemId={extSystemId}
              extObjectId={extObjectId}
              contractSlug={contractSlug}
              contractExtUrl={contractExtUrl}
            />
          }
        </Box>
        <Box display="flex">

          <Button onClick={() => setSelectTab(selectTab === TABLE_TYPE.IN ? '' : TABLE_TYPE.IN)}
                  color={selectTab === TABLE_TYPE.IN ? 'primary' : undefined}
                  className={classes.linkTab}>
            <ArchiveIcon fontSize="large"/>
            <div className={classes.linkTabText}>
              Přijaté zprávy
            </div>
            <div>
              {counts.countIncoming} {!!counts.countUnreadIncoming && <strong>({counts.countUnreadIncoming})</strong>}
            </div>
          </Button>
          <Button onClick={() => setSelectTab(selectTab === TABLE_TYPE.OUT ? '' : TABLE_TYPE.OUT)}
                  color={selectTab === TABLE_TYPE.OUT ? 'primary' : undefined}
                  className={classes.linkTab}>
            <UnarchiveIcon fontSize="large"/>
            <div className={classes.linkTabText}>
              Odeslané zprávy
            </div>
            <div>
              {counts.countOutgoing} {!!counts.countUnreadOutgoing && <strong>({counts.countUnreadOutgoing})</strong>}
            </div>
          </Button>

          <Button onClick={() => setSelectTab(selectTab === TABLE_TYPE.SUBM ? '' : TABLE_TYPE.SUBM)}
                  color={selectTab === TABLE_TYPE.SUBM ? 'primary' : undefined}
                  className={classes.linkTab}>
            <DescriptionIcon fontSize="large"/>
            <div className={classes.linkTabText}>
              Podání
            </div>
            <div>
              {counts.countSubmissions}
            </div>
          </Button>
        </Box>
      </Box>

      {selectTab &&
        <Box className={classes.listWrap}>
          {selectTab === TABLE_TYPE.IN &&
            <MsgsReceivedListMin extSystemId={extSystemId} extObjectId={extObjectId}/>
          }
          {selectTab === TABLE_TYPE.OUT &&
            <MsgsSentListMin extSystemId={extSystemId} extObjectId={extObjectId}/>
          }
          {selectTab === TABLE_TYPE.SUBM &&
            <MsgsSubmissionsListMin extSystemId={extSystemId} extObjectId={extObjectId}/>
          }
        </Box>
      }

    </Paper>
  )
}

export default EkomContractActions
